<!-- 
<div class="container" theme [styleObj]='brandStyleTheme'>

    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card">
  
            <div class="card-header">
    
                <ng-template headerSection></ng-template>
    
            </div>
  
            <div class="card-body">
 -->

<div class="wp-title">
  <h3 class="text-center">{{subtitleText}}</h3>
</div>

              @if (isDetailsShown) {
                <div class="row alert ">
                  <h5 class="text-center">{{detailsText}}</h5>
                </div>
              }

              <div class="row wp-image-text">
                    @if (isAddToAppleWalletImageShown) {
                      <div class="image-text__image" style="text-align: center;">
                        <a  href="{{enrollUrl}}">
                          <img class="img-fluid mx-auto d-block" [src]="addToAppleWalletImage" >
                        </a>
                      </div>
                    }
                    <!-- @if (isTitleShown) {
                        <div class="wp-image-text-text">
                            <h4 class="text-center">{{titleText}}</h4>
                        </div>
                    } -->
                </div>

                <div class="row">
                    <div class="col-6 text-center">
                        <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Cancel</button>
                    </div>
                </div>
<!-- 
            </div>

            <div class="card-footer">

                <ng-template footerSection></ng-template>

            </div>
  
  
        </div>
      </div>
    </div>
  
  </div>
  
   -->
